import { MutationTree } from "vuex";
import { CandidateState } from "./types";

export const mutations: MutationTree<CandidateState> = {};
